import React, { useRef, useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import gsap from 'gsap';
import './styles/App.css';
import ProtectedRoute from './components/ProtectedRoute';
import HeaderWrapper from './components/HeaderWrapper';
import Products from './components/Products';
import ProductManager from './components/ProductManager';
import ProductDetails from './components/ProductDetails';
import Login from './components/Login';
import Register from './components/Register';
import AddBrand from './components/AddBrand';
import Funcionarios from './components/Funcionarios';
import CadastrarFuncionario from './components/CadastrarFuncionario';
import ProductsByBrand from './components/ProductsByBrand';
import Footer from './components/Footer';
import SearchProducts from './components/SearchProducts';
import EditProduct from './components/EditProduct';
import AdicionarMarcaProduto from './components/AdicionarMarcaProduto';
import CardsApp from './components/CardsApp';
import Success from './components/Success';
import Failure from './components/Failure';
import Pending from './components/Pending';

import WhatsAppButton from './components/WhatsAppButton';
import VerifyEmail from './components/VerifyEmail';
import CookieConsent from './components/CookieConsent';
import UserManager from './components/UserManager';
import Pedidos from './components/Pedidos';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import SobreNos from './components/SobreNos';
import PoliticaDePrivacidade from './components/PoliticaDePrivacidade';
import TermosDeUso from './components/TermosDeUso';
import BannerCarousel from './components/BannerCarousel';

function App() {
  const boltRef = useRef(null);
  const [isStaff, setIsStaff] = useState(false);

  // Atualiza o estado de isStaff com base no localStorage
  useEffect(() => {
    const storedIsStaff = localStorage.getItem('is_staff') === 'true';
    setIsStaff(storedIsStaff);
  }, []);

  const handleMouseEnter = (boltElement) => {
    const div = boltElement.querySelector('div');

    if (!boltElement.classList.contains('animate')) {
      boltElement.classList.add('animate');

      const tween = gsap.timeline({
        onComplete() {
          boltElement.classList.remove('animate');
        },
      })
        .set(div, { rotation: 360 })
        .to(div, { y: 80, rotation: 370, duration: 0.7 })
        .to(div, { y: -140, rotation: 20, duration: 0.6 })
        .to(div, { y: 80, rotation: -24, duration: 0.1 })
        .to(div, { y: 0, rotation: 0, ease: 'back.out(1.6)', duration: 0.8 });
    }
  };

  const clientId = '152810839335-hbrhn3m4civ8845epi2n3kkre2m54scv.apps.googleusercontent.com';
  
  const currentYear = new Date().getFullYear();
  const foundationYear = 1975; // Ano de fundação da empresa
  const yearsOfTradition = currentYear - foundationYear;
  
  return (
    <GoogleOAuthProvider clientId={clientId}>
      <Router>
        <HeaderWrapper>
          <Routes>
            <Route
              path="/"
              element={
                <div>
                  <BannerCarousel />
                  <div>
                    <CardsApp />
                  </div>
                  <Products />
                  
                  <ProductsByBrand brandName="Hercules" />
                </div>
              }
            />
            <Route
              path="/funcionarios"
              element={
                <ProtectedRoute requireStaff={true}>
                  <Funcionarios />
                </ProtectedRoute>
              }
            >
              <Route path="gerenciar-produtos" element={<ProductManager />} />
              <Route path="cadastrar-funcionario" element={<CadastrarFuncionario />} />
              <Route path="editar-produto/:id" element={<EditProduct />} />
              <Route path="adicionar-marca-produto" element={<AdicionarMarcaProduto />} />
              <Route path="gerenciar-usuarios" element={<UserManager />} />
            
            </Route>
            <Route path="/produto/:id" element={<ProductDetails />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/adicionar-marca" element={<AddBrand />} />
            <Route path="/pesquisar-produtos" element={<SearchProducts />} />
            <Route path="/sucesso" element={<Success />} />
            <Route path="/falha" element={<Failure />} />
            <Route path="/pendente" element={<Pending />} />
           
            <Route path="/verify-email/:uid/:token" element={<VerifyEmail />} />
            <Route path="/meus-pedidos" element={<Pedidos />} /> 
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:uid/:token" element={<ResetPassword />} />
            <Route path="/sobre-nos" element={<SobreNos />} />
            <Route path="/politica-de-privacidade" element={<PoliticaDePrivacidade />} />
            <Route path="/termos-de-uso" element={<TermosDeUso />} />
           
          </Routes>

          {/* Exibe o botão do WhatsApp apenas se o usuário não for funcionário */}
          {!isStaff && <WhatsAppButton />}
        </HeaderWrapper>
        <CookieConsent />
        <Footer />
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;